/**
 * @generated SignedSource<<4ab8d2d638690ac877423f8a7cf2d5f5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MetaAdCallToAction = "CONTACT_US" | "GET_QUOTE" | "LEARN_MORE" | "SHOP_NOW" | "SIGN_UP" | "SUBSCRIBE" | "%future added value";
export type CreateMetaAdRequest = {
  brandId: string;
  callToAction?: MetaAdCallToAction | null;
  description?: string | null;
  destinationUrl?: string | null;
  displayUrl?: string | null;
  dominantColor?: string | null;
  facebookPageId?: string | null;
  headline?: string | null;
  instagramAccountId?: string | null;
  metaAdSetIds?: ReadonlyArray<string> | null;
  name?: string | null;
  primaryText?: string | null;
};
export type MetaAdsFilter = {
  approved?: boolean | null;
  count?: number | null;
  created?: boolean | null;
  cursor?: string | null;
  submittedForApproval?: boolean | null;
};
export type CreativeDrawerCreateMetaAdMutation$variables = {
  input: CreateMetaAdRequest;
  metaAdsFilter?: MetaAdsFilter | null;
};
export type CreativeDrawerCreateMetaAdMutation$data = {
  readonly createMetaAd: {
    readonly brand: {
      readonly draftMetaAdCount: number;
      readonly id: string;
      readonly unapprovedMetaAdCount: number;
      readonly " $fragmentSpreads": FragmentRefs<"CreativeList" | "SubmitCreativeForApprovalConfirmDialogBrand">;
    };
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"CreativeDrawerMetaAd">;
  };
};
export type CreativeDrawerCreateMetaAdMutation = {
  response: CreativeDrawerCreateMetaAdMutation$data;
  variables: CreativeDrawerCreateMetaAdMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "metaAdsFilter"
  }
],
v1 = {
  "kind": "Variable",
  "name": "metaAdsFilter",
  "variableName": "metaAdsFilter"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  },
  (v1/*: any*/)
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "draftMetaAdCount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unapprovedMetaAdCount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "approved",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "submittedForApproval",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "picture",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "Comment",
  "kind": "LinkedField",
  "name": "comments",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullName",
          "storageKey": null
        },
        (v10/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "Insight",
  "kind": "LinkedField",
  "name": "insights",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMet",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "callToAction",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "destinationUrl",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayUrl",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headline",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryText",
  "storageKey": null
},
v22 = [
  (v3/*: any*/),
  (v16/*: any*/),
  (v10/*: any*/)
],
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "MetaAdSet",
  "kind": "LinkedField",
  "name": "metaAdSet",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v16/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "campaignName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MetaAdAccount",
      "kind": "LinkedField",
      "name": "metaAdAccount",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v16/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "effectiveStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "facebookPageId",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "instagramAccountId",
  "storageKey": null
},
v26 = [
  (v16/*: any*/),
  (v10/*: any*/),
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreativeDrawerCreateMetaAdMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "MetaAd",
        "kind": "LinkedField",
        "name": "createMetaAd",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CreativeDrawerMetaAd"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Brand",
            "kind": "LinkedField",
            "name": "brand",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SubmitCreativeForApprovalConfirmDialogBrand"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CreativeList"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreativeDrawerCreateMetaAdMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "MetaAd",
        "kind": "LinkedField",
        "name": "createMetaAd",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "VisualAsset",
            "kind": "LinkedField",
            "name": "visualAssets",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/)
            ],
            "storageKey": null
          },
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "FacebookPage",
            "kind": "LinkedField",
            "name": "facebookPage",
            "plural": false,
            "selections": (v22/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InstagramAccount",
            "kind": "LinkedField",
            "name": "instagramAccount",
            "plural": false,
            "selections": (v22/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetaAdMetaAdSet",
            "kind": "LinkedField",
            "name": "metaAdMetaAdSets",
            "plural": true,
            "selections": [
              (v23/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v24/*: any*/),
          (v25/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Brand",
            "kind": "LinkedField",
            "name": "brand",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "invalidDraftMetaAdCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v1/*: any*/)
                ],
                "concreteType": "MetaAd",
                "kind": "LinkedField",
                "name": "metaAds",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v15/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FacebookPage",
                    "kind": "LinkedField",
                    "name": "facebookPage",
                    "plural": false,
                    "selections": (v26/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InstagramAccount",
                    "kind": "LinkedField",
                    "name": "instagramAccount",
                    "plural": false,
                    "selections": (v26/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MetaAdMetaAdSet",
                    "kind": "LinkedField",
                    "name": "metaAdMetaAdSets",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v23/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "VisualAsset",
                    "kind": "LinkedField",
                    "name": "visualAssets",
                    "plural": true,
                    "selections": [
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v11/*: any*/),
                  (v14/*: any*/),
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Brand",
                    "kind": "LinkedField",
                    "name": "brand",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "955bd4384bfd053693ad558198086c82",
    "id": null,
    "metadata": {},
    "name": "CreativeDrawerCreateMetaAdMutation",
    "operationKind": "mutation",
    "text": "mutation CreativeDrawerCreateMetaAdMutation(\n  $input: CreateMetaAdRequest!\n  $metaAdsFilter: MetaAdsFilter\n) {\n  createMetaAd(input: $input, metaAdsFilter: $metaAdsFilter) {\n    id\n    ...CreativeDrawerMetaAd\n    brand {\n      id\n      draftMetaAdCount\n      unapprovedMetaAdCount\n      ...SubmitCreativeForApprovalConfirmDialogBrand\n      ...CreativeList\n    }\n  }\n}\n\nfragment Comment on Comment {\n  id\n  createdAt\n  text\n  user {\n    id\n    fullName\n    picture\n  }\n}\n\nfragment CommentList on MetaAd {\n  comments {\n    id\n    ...Comment\n  }\n}\n\nfragment CreativeAdvisorInsight on Insight {\n  text\n  isMet\n}\n\nfragment CreativeAdvisorMetaAd on MetaAd {\n  insights {\n    id\n    text\n    ...CreativeAdvisorInsight\n  }\n}\n\nfragment CreativeDrawerMetaAd on MetaAd {\n  id\n  approved\n  created\n  submittedForApproval\n  comments {\n    id\n  }\n  visualAssets {\n    id\n  }\n  ...CreativeAdvisorMetaAd\n  ...CreativeTextForm\n  ...CommentList\n  ...MetaAdPreview\n}\n\nfragment CreativeList on Brand {\n  metaAds(metaAdsFilter: $metaAdsFilter) {\n    id\n    ...MetaAd\n  }\n}\n\nfragment CreativeTextForm on MetaAd {\n  id\n  callToAction\n  name\n  description\n  destinationUrl\n  displayUrl\n  headline\n  primaryText\n  facebookPage {\n    id\n    name\n    picture\n  }\n  instagramAccount {\n    id\n    name\n    picture\n  }\n  metaAdMetaAdSets {\n    metaAdSet {\n      id\n      name\n      campaignName\n      metaAdAccount {\n        id\n        name\n      }\n      effectiveStatus\n      status\n    }\n  }\n}\n\nfragment MetaAd on MetaAd {\n  ...MetaAdPreview\n  ...CreativeDrawerMetaAd\n  id\n  approved\n  submittedForApproval\n  created\n  name\n  callToAction\n  description\n  destinationUrl\n  displayUrl\n  headline\n  primaryText\n  facebookPageId\n  instagramAccountId\n  brand {\n    id\n  }\n  comments {\n    id\n  }\n  visualAssets {\n    id\n  }\n}\n\nfragment MetaAdPreview on MetaAd {\n  id\n  callToAction\n  description\n  destinationUrl\n  displayUrl\n  headline\n  primaryText\n  facebookPageId\n  instagramAccountId\n  facebookPage {\n    name\n    picture\n  }\n  instagramAccount {\n    name\n    picture\n  }\n  metaAdMetaAdSets {\n    id\n  }\n  visualAssets {\n    type\n    url\n  }\n}\n\nfragment SubmitCreativeForApprovalConfirmDialogBrand on Brand {\n  id\n  invalidDraftMetaAdCount\n}\n"
  }
};
})();

(node as any).hash = "5edbbc1edd177a48a2abf1eddb231e7f";

export default node;
